import React from 'react';
import SMSearchFormBaseView from 'components/search/SMSearchFormBaseView';

class SMCategoryHomeSearchFormView extends SMSearchFormBaseView {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.priceType !== nextProps.priceType){
      this.setState({priceType: nextProps.priceType});
    }
  }
  
  render() {

    let responsiveClass={};
    switch (this.state.priceType) {
      case 'hourly':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-4',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-6 col-sm-6 col-md-3',
          end: '',
          capacity: 'col-xs-6 col-sm-6 col-md-2 search-filter__person-num',
        };
        break;
      case 'stay':
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-4',
          priceType: '',
          start: 'col-xs-6 col-sm-6 col-md-2',
          end: 'col-xs-6 col-sm-6 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
        break;
      default:
        responsiveClass = {
          area: 'col-xs-9 col-sm-9 col-md-3',
          priceType: 'col-xs-3 col-sm-3 col-md-1',
          start: 'col-xs-6 col-sm-6 col-md-2',
          end: 'col-xs-6 col-sm-6 col-md-2',
          capacity: 'col-xs-12 col-sm-12 col-md-2 search-filter__person-num',
        };
    }
    return (
      <div className="container">
        <div className="row">
          <input type="hidden" name="event_type" value={this.props.eventType} />
          <input type="hidden" name="space_type" value={this.props.spaceType} />
          <input type="hidden" name="amenities" value={this.props.amenities} />
          {this.renderAreaField(responsiveClass.area)}
          {this.renderPriceTypeSelect(responsiveClass.priceType)}
          {this.renderStartedAtField(responsiveClass.start)}
          {this.renderEndedAtField(responsiveClass.end)}
          {this.renderCapacityRange(responsiveClass.capacity)}
          <div className="col-xs-12 col-sm-12 col-md-2">
            <div className="search-box-button-area">
              <input className="form-btn form-btn__blue form-btn-top" name="" type="submit" value="検索" />
            </div>
          </div>
          {this.renderDatePicker('datetime-layout clearfix')}
        </div>
      </div>
    );
  }
}
export default SMCategoryHomeSearchFormView;




// WEBPACK FOOTER //
// ./app/javascript/components/categories/SMCategoryHomeSearchFormView.jsx